import React from 'react';
import Helmet from 'react-helmet';
import language from './utils/browserLanguage';

const titleEN = 'sipgate login';
const descriptionEN = 'Log in to your sipgate account: sipgate team ✓ sipgate basic ✓ sipgate trunking ✓';

const metaTagsEN = [
	{
		name: 'description',
		content: descriptionEN,
	},
	{
		property: 'og:locale',
		content: 'en_GB',
	},
	{
		property: 'og:title',
		content: titleEN,
	},
	{
		property: 'og:description',
		content: titleEN,
	},
];

const remove = (parentTag, childTagQuery) => {
	const tagSelector = parentTag.querySelectorAll(childTagQuery);
	if (tagSelector.length > 0) {
		parentTag.removeChild(tagSelector[0]);
	}
};

const removeDefaultHeadTags = () => {
	const head = document.getElementsByTagName('head')[0];
	remove(head, '[name="description"]');
	remove(head, 'title');
	remove(head, '[property="og:description"]');
	remove(head, '[property="og:title"]');
	remove(head, '[property="og:locale"]');
};

const Head = () => {
	if (language === 'EN') {
		removeDefaultHeadTags();
		return (
			<Helmet
				htmlAttributes={{ lang: 'en' }}
				title={titleEN}
				meta={[
					...metaTagsEN,
				]}
			/>
		);
	}
	return null;
};

export default Head;



// WEBPACK FOOTER //
// ./src/Head.js